import useMessageTemplateCreateRouteConfig from "../../../routes/configs/message_templates/MessageTemplateCreateRouteConfig";
import useMessageTemplateEditRouteConfig from "../../../routes/configs/message_templates/MessageTemplateEditRouteConfig";
import DataTable, { useDataTable } from "../main/DataTable";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";

function MessageTemplatesDataTable() {
  //Create the datatable config
  const config = new DataTableConfig("message_templates");

  //Set the datatable fetch info
  config.setFetchRequest("message_templates");

  //Set default order
  config.setOrderBy("name");
  config.setOrderDirection("asc");

  //Set the datatable comuns
  config.setColumns([
    useBasicColumnConfig("name").setLockActive(true),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig(
      "message_template",
      useMessageTemplateEditRouteConfig()
    ),
    useDeleteRowActionConfig("message_template"),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig(
      "message_template",
      useMessageTemplateCreateRouteConfig()
    ),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default MessageTemplatesDataTable;
